import {
  AutocompleteItemType,
  LawyerItemType,
  EnterpriseItemType,
  LawFirmItemType,
  QueryItemType,
} from './searchAutocomplete.types';
import { autocompleteDelimiters } from './autocompleteConstants';
import { getLegislationName } from '../../../../legislation/utils/legislationUtils';

export function removeAutocompleteHighlights(str: string) {
  return str.replace(
    new RegExp(
      `(${autocompleteDelimiters.preTag}|${autocompleteDelimiters.postTag})`,
      'g',
    ),
    '',
  );
}

export function getLawyerName({ metadata }: Pick<LawyerItemType, 'metadata'>) {
  return `${metadata.firstname} ${metadata.lastname}`;
}

export function getEnterpriseName({
  metadata,
}: Pick<EnterpriseItemType, 'metadata'>) {
  let commercialPart = '';
  if (metadata.commercial_name) {
    commercialPart = ` (${metadata.commercial_name})`;
  }
  return `${metadata.corporate_name}${commercialPart}`;
}

export function getQueryLabel({
  suggestion,
}: Pick<QueryItemType, 'suggestion'>) {
  return removeAutocompleteHighlights(suggestion);
}

export function getLawyerUrl(item: LawyerItemType) {
  return `/p/avocat/${item.metadata.lawyer_id}`;
}

export function getEnterpriseUrl(item: EnterpriseItemType) {
  return `/e/${item.metadata.enterprise_id}`;
}

export function getLawFirmUrl(item: LawFirmItemType) {
  return `/p/cabinet/${item.metadata.law_firm_id}`;
}

export function getLabel(item: AutocompleteItemType) {
  if (item.type === 'lawyer') {
    return getLawyerName(item);
  }

  if (item.type === 'law_firm') {
    return item.metadata.law_firm_name;
  }
  if (item.type === 'enterprise') {
    return getEnterpriseName(item);
  }
  if (item.type === 'legislation') {
    return getLegislationName(
      item.metadata.article_number,
      item.metadata.legislation_type,
      item.metadata.legislation_name,
    );
  }
  return getQueryLabel(item);
}
